module.exports = __webpack_public_path__ + "static/media/Ico-7.acedbc56.png";